import { useEffect } from 'react';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import snackbarStore from '../../../../../stores/Snackbar.store';
import { UseAsyncAutocompleteLoadErrorParams } from '../asyncAutocomplete.types';

export const useAsyncAutocompleteLoadError = ({
  listError,
  valueError,
}: UseAsyncAutocompleteLoadErrorParams) => {
  const { translate } = useTranslation();

  useEffect(() => {
    if (!listError && !valueError) {
      return;
    }

    snackbarStore.handleMessage({
      message: translate(LangEnum.SNACKBAR_REFRESH_PAGE),
      type: 'error',
    });
  }, [listError, valueError, translate]);
};
